import React from 'react';
import { withAuthorization } from '../Session';
import { Container, div, Row, Col } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import './styles.css';
import Spinner from 'react-bootstrap/Spinner';

class Help extends React.Component {
    state = {
        showLoading: false,
        alert: 0,
        flag1: false,
        green: false
    };

    // divs1=[]
    async componentDidMount() {}

    toggleClass(divid) {
        const openList = document.querySelectorAll('.open');
        for (let i = 0; i < openList.length; i++) {
            openList[i].className = 'closed';
        }

        const oldClassName = document.getElementById(divid).className;
        const newClassName = oldClassName === 'closed' ? 'open' : 'closed';
        document.getElementById(divid).className = newClassName;
    }

    render() {
        let help1Content = [];
        for (let i = 0; i < 5; i++) {
            let divId = i;
            help1Content.push(
                <div
                    key={'help1_' + i}
                    id={'help1_' + divId}
                    onClick={(i) => this.toggleClass('help1_' + divId)}
                    className={'closed'}
                >
                    <p className="help_title">How can we help you?</p>
                    <p className="help_date">
                        Validated on 6 May 2020 • Posted on 6 May 2020{' '}
                    </p>
                    <p className="help_description">
                        There are three ways to manually back up a Droplet. You
                        can create a DigitalOcean snapshot for an on-demand full
                        disk image, convert an automatic DigitalOcean backup
                        into a snapshot, or use a third-party tool for a partial
                        backup.
                    </p>
                    <hr />
                </div>
            );
        }

        let help2Content = [];
        for (let i = 0; i < 5; i++) {
            let divId = i;
            help2Content.push(
                <div
                    key={'help2_' + i}
                    id={'help2_' + divId}
                    onClick={(i) => this.toggleClass('help2_' + divId)}
                    className={'closed'}
                >
                    <p className="help_title">How can we help you?</p>
                    <p className="help_date">
                        Validated on 6 May 2020 • Posted on 6 May 2020{' '}
                    </p>
                    <p className="help_description">
                        There are three ways to manually back up a Droplet. You
                        can create a DigitalOcean snapshot for an on-demand full
                        disk image, convert an automatic DigitalOcean backup
                        into a snapshot, or use a third-party tool for a partial
                        backup.
                    </p>
                    <hr />
                </div>
            );
        }

        let help3Content = [];
        for (let i = 0; i < 5; i++) {
            let divId = i;
            help3Content.push(
                <div
                    key={'help3_' + i}
                    id={'help3_' + divId}
                    onClick={(i) => this.toggleClass('help3_' + divId)}
                    className={'closed'}
                >
                    <p className="help_title">How can we help you?</p>
                    <p className="help_date">
                        Validated on 6 May 2020 • Posted on 6 May 2020{' '}
                    </p>
                    <p className="help_description">
                        There are three ways to manually back up a Droplet. You
                        can create a DigitalOcean snapshot for an on-demand full
                        disk image, convert an automatic DigitalOcean backup
                        into a snapshot, or use a third-party tool for a partial
                        backup.
                    </p>
                    <hr />
                </div>
            );
        }

        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <Col>
                        <h4>How can we help you?</h4>
                        <hr />
                    </Col>
                </Row>
                <Tabs>
                    <Tab eventKey="help1" title="Payment Issue">
                        <div className="help_inner">{help1Content}</div>
                    </Tab>
                    <Tab eventKey="help2" title="My Store is not working">
                        <div className="help_inner">{help2Content}</div>
                    </Tab>
                    <Tab eventKey="help3" title="Cant Track Order">
                        <div className="help_inner">{help3Content}</div>
                    </Tab>
                </Tabs>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Help);
